export default __webpack_public_path__ + "static/media/shield-vault.60d9c7be.png";